module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby Default Starter"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 105
// module chunks = 60335399758886 114276838955818